import React from 'react';
import Image from 'next/image';

type Props = {
  size: number;
  showText?: boolean;
};

export default function Logo({ size, showText }: Props) {
  return (
    <div className="flex flex-row items-center">
      <div style={{ width: size, height: size }}>
        <Image
          src={'/images/logo.png'}
          width={size}
          height={size}
          alt={'TopHouse Logo'}
        />
      </div>
      {showText && <p className={'m-0 ml-1'}>TopHouse</p>}
    </div>
  );
}
